var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgManage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 22H25M7 22H9M9 22C9 23.3807 10.1193 24.5 11.5 24.5C12.8807 24.5 14 23.3807 14 22C14 20.6193 12.8807 19.5 11.5 19.5C10.1193 19.5 9 20.6193 9 22ZM24 16H25M7 16H14M17 10H25M17 10C17 8.61929 15.8807 7.5 14.5 7.5C13.1193 7.5 12 8.61929 12 10C12 11.3807 13.1193 12.5 14.5 12.5C15.8807 12.5 17 11.3807 17 10ZM7 10H8M20.5 18.5C19.1193 18.5 18 17.3807 18 16C18 14.6193 19.1193 13.5 20.5 13.5C21.8807 13.5 23 14.6193 23 16C23 17.3807 21.8807 18.5 20.5 18.5Z",
    stroke: "#2D53DA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManage);
export default __webpack_public_path__ + "static/media/Manage.70df92faddc4e90c11a4278e9a15796b.svg";
export { ForwardRef as ReactComponent };